export const ProductTypes = [
    {label: 'Sidamo',value: 'sidamo'},
    {label: 'Fournisseur',value: 'supplier'},
    {label: 'Concurrent',value: 'competitor'},
]



// WEBPACK FOOTER //
// ./src/config/enum/ProductTypes.js